module.exports = __webpack_public_path__ + "media/images/emblems/Luthern_LU-d215119fd4fca8d7bb992659320a53a0.png";